<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="400">
      <template v-slot:activator="{ on }">
        <v-btn
          title="Reactivate user"
          text
          x-small
          v-on="on"
          v-on:click="activateDialog"
          ><icon icon="user" color="primary"
        /></v-btn>
      </template>

      <v-card class="mx-auto primary--text">
        <v-card-title>Reactivate User</v-card-title>

        <v-card-text>
          <p>
            Do you want to reactivate user {{ userName }}? User will now be able
            to log into the Omni Portal.
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="cancel">Cancel</v-btn>
          <v-btn color="primary" text @click="reactivateUser"
            >Reactivate User</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["user"],
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    userName: function () {
      return this.user.userName;
    },
  },
  methods: {
    activateDialog: function () {
      this.$store.commit("usersModule/setUser", this.user);
      this.dialog = true;
    },
    reactivateUser: async function () {
      await this.$store.dispatch("usersModule/enableUser");
      this.dialog = false;
    },
    cancel: function () {
      this.$store.commit("usersModule/clearUser");
      this.dialog = false;
    },
  },
};
</script>
